<template>
	<div>
		<div id="header-wrapper">
			<div class="header">
				<h1>Colors</h1>
				<span>Product</span>
			</div>
		</div>
		<!--Content-->
		<div id="content">
			<h2>Primary colors</h2>
			<div v-for="color in primaryColors" :key="color.name" class="color-box type1">
				<div class="color" :class="color.color + ' mt--'+color.color + ' mt--bg--'+color.color"></div>
				<div class="desc mt--bg--neutrals-light-gray-01" :class="color.color">
					<ul>
						<li class="name mt--black">{{color.name}}</li>
						<li><span class="label">HEX</span><span class="value">{{color.hex}}</span></li>
						<li><span class="label">RGB</span><span class="value">{{color.rgb}}</span></li>
					</ul>
				</div>
				<div class="usage mt--neutrals-dark-gray-01">
					{{color.usage}}
				</div>
			</div>

			<h2>Secondary colors</h2>
			<div v-for="color in SecondaryColors" :key="color.name" class="color-box type1">
				<div class="color" :class="color.color + ' mt--'+color.color + ' mt--bg--'+color.color"></div>
				<div class="desc mt--bg--neutrals-light-gray-01"  :class="color.color">
					<ul>
						<li class="name mt--black">{{color.name}}</li>
						<li><span class="label">HEX</span><span class="value">{{color.hex}}</span></li>
						<li><span class="label">RGB</span><span class="value">{{color.rgb}}</span></li>
					</ul>
				</div>
				<div class="usage mt--neutrals-dark-gray-01">
					{{color.usage}}
				</div>
			</div>

			<h2>Neutrals</h2>
			<div v-for="color in Neutrals" :key="color.name" class="color-box type1">
				<div class="color" :class="color.color + ' mt--'+color.color + ' mt--bg--'+color.color"></div>
				<div class="desc mt--bg--neutrals-light-gray-01"  :class="color.color">
					<ul>
						<li class="name mt--black">{{color.name}}</li>
						<li><span class="label">HEX</span><span class="value">{{color.hex}}</span></li>
						<li><span class="label">RGB</span><span class="value">{{color.rgb}}</span></li>
					</ul>
				</div>
				<div class="usage mt--neutrals-dark-gray-01">
					{{color.usage}}
				</div>
			</div>

			<h2>Extended colors</h2>
			<div v-for="color in PrimaryExtendedColors" :key="color.name" class="color-box color-box--type2">
				<div class="color" :class="color.color + ' mt--'+color.color + ' mt--bg--'+color.color"></div>
				<div class="desc">
					<ul>
						<li class="name mt--black">{{color.name}}</li>
						<li><span class="label">HEX</span><span class="value">{{color.hex}}</span></li>
						<li><span class="label">RGB</span><span class="value">{{color.rgb}}</span></li>
					</ul>
				</div>
				<div class="usage mt--neutrals-dark-gray-01">
					{{color.usage}}
				</div>
			</div>
			<div class="mt--clearfix"></div>
			<div v-for="color in SuccessExtendedColors" :key="color.name" class="color-box color-box--type2">
				<div class="color" :class="color.color + ' mt--'+color.color + ' mt--bg--'+color.color"></div>
				<div class="desc">
					<ul>
						<li class="name mt--black">{{color.name}}</li>
						<li><span class="label">HEX</span><span class="value">{{color.hex}}</span></li>
						<li><span class="label">RGB</span><span class="value">{{color.rgb}}</span></li>
					</ul>
				</div>
				<div class="usage mt--neutrals-dark-gray-01">
					{{color.usage}}
				</div>
			</div>
			<div class="mt--clearfix"></div>
			<div v-for="color in ErrorExtendedColors" :key="color.name" class="color-box color-box--type2">
				<div class="color" :class="color.color + ' mt--'+color.color + ' mt--bg--'+color.color"></div>
				<div class="desc">
					<ul>
						<li class="name mt--black">{{color.name}}</li>
						<li><span class="label">HEX</span><span class="value">{{color.hex}}</span></li>
						<li><span class="label">RGB</span><span class="value">{{color.rgb}}</span></li>
					</ul>
				</div>
				<div class="usage mt--neutrals-dark-gray-01">
					{{color.usage}}
				</div>
			</div>
			<div class="mt--clearfix"></div>
			<div v-for="color in WarningExtendedColors" :key="color.name" class="color-box color-box--type2">
				<div class="color" :class="color.color + ' mt--'+color.color + ' mt--bg--'+color.color"></div>
				<div class="desc">
					<ul>
						<li class="name mt--black">{{color.name}}</li>
						<li><span class="label">HEX</span><span class="value">{{color.hex}}</span></li>
						<li><span class="label">RGB</span><span class="value">{{color.rgb}}</span></li>
					</ul>
				</div>
				<div class="usage mt--neutrals-dark-gray-01">
					{{color.usage}}
				</div>
			</div>
			<div class="mt--clearfix"></div>
			<div v-for="color in InfoExtendedColors" :key="color.name" class="color-box color-box--type2">
				<div class="color" :class="color.color + ' mt--'+color.color + ' mt--bg--'+color.color"></div>
				<div class="desc">
					<ul>
						<li class="name mt--black">{{color.name}}</li>
						<li><span class="label">HEX</span><span class="value">{{color.hex}}</span></li>
						<li><span class="label">RGB</span><span class="value">{{color.rgb}}</span></li>
					</ul>
				</div>
				<div class="usage mt--neutrals-dark-gray-01">
					{{color.usage}}
				</div>
			</div>
		</div>
		<!--//Content-->


	</div>
</template>

<script>
export default {
	name: 'colors-page',
	props: [],
	components: {

	},
	data () {
		return {
			primaryColors: [
				{ 'name': 'Blue', 'color':'primary', 'hex': '#097DB7', 'rgb': '125, 183, 100', 'usage': 'Primary buttons, links, active ' },
				{ 'name': 'Dark gray 02', 'color':'primary-dark-gray', 'hex': '#485464', 'rgb': '72, 84, 100', 'usage': 'Text, icon' },
				{ 'name': 'Light gray 01', 'color':'primary-light-gray', 'hex': '#F6F7FA', 'rgb': '246, 247, 250', 'usage': 'Light background' },
				{ 'name': 'White', 'color':'white', 'hex': '#FFFFFF', 'rgb': '255, 255, 255', 'usage': 'Cards background, toolbar, background, modals, forms, text, icon' },
			],
			SecondaryColors: [
				{ 'name': 'Success', 'color':'success', 'hex': '#00C853', 'rgb': '200, 83, 100', 'usage': '' },
				{ 'name': 'Error', 'color':'error', 'hex': '#F44336', 'rgb': '244, 67, 54', 'usage': '' },
				{ 'name': 'Warning', 'color':'warning', 'hex': '#FFC107', 'rgb': '255, 193, 7', 'usage': '' },
				{ 'name': 'Information', 'color':'info', 'hex': '#7364FF', 'rgb': '115, 100, 255', 'usage': '' },
			],
			Neutrals: [
				{ 'name': 'Black', 'color':'black', 'hex': '#171B20', 'rgb': '0, 0, 0', 'usage': 'Text' },
				{ 'name': 'Dark gray 02', 'color':'neutrals-dark-gray-02', 'hex': '#485464', 'rgb': '72, 84, 100', 'usage': 'Text, icon' },
				{ 'name': 'Dark gray 01', 'color':'neutrals-dark-gray-01', 'hex': '#718091', 'rgb': '113, 128, 145', 'usage': 'Text, caption' },
				{ 'name': 'Light gray 03', 'color':'neutrals-light-gray-03', 'hex': '#B2C0D0', 'rgb': '178, 192, 208', 'usage': 'Borders' },
				{ 'name': 'Light gray 02', 'color':'neutrals-light-gray-02', 'hex': '#EDEFF3', 'rgb': '237, 239, 243', 'usage': 'Input box' },
				{ 'name': 'Light gray 01', 'color':'neutrals-light-gray-01', 'hex': '#F6F7FA', 'rgb': '246, 247, 250', 'usage': 'Light background' },
				{ 'name': 'White', 'color':'white', 'hex': '#FFFFFF', 'rgb': '255, 255, 255', 'usage': 'Cards background, toolbar, background, modals, forms, text, icon' },
			],
			PrimaryExtendedColors: [
				{ 'name': 'P-Active dark', 'color':'primary-active-dark', 'hex': '#004AD4', 'rgb': '0, 74, 212', 'usage': '' },
				{ 'name': 'P-Hover dark', 'color':'primary-hover-dark', 'hex': '#0050E9', 'rgb': '0, 80, 233', 'usage': '' },
				{ 'name': 'Primary', 'color':'primary', 'hex': '#055AFE', 'rgb': '5, 90, 254', 'usage': '' },
				{ 'name': 'P-Lighten 01', 'color':'primary-Lighten-01', 'hex': '#508CFE', 'rgb': '80, 140, 254', 'usage': '' },
				{ 'name': 'P-Lighten 02', 'color':'primary-Lighten-02', 'hex': '#82ACFE', 'rgb': '130, 172, 254', 'usage': '' },
				{ 'name': 'P-Lighten 03', 'color':'primary-Lighten-03', 'hex': '#A8C6FF', 'rgb': '168, 198, 255', 'usage': '' },
				{ 'name': 'P-Lighten 04', 'color':'primary-Lighten-04', 'hex': '#EDF3FF', 'rgb': '237, 243, 255', 'usage': '' },
			],
			SuccessExtendedColors: [
				{ 'name': 'Success', 'color':'success', 'hex': '#00C853', 'rgb': '200, 83, 100', 'usage': '' },
				{ 'name': 'S-Lighten 01', 'color':'success-lighten-01', 'hex': '#7FE3A9', 'rgb': '127, 227, 169', 'usage': '' },
				{ 'name': 'S-Lighten 02', 'color':'success-lighten-02', 'hex': '#CCF4DC', 'rgb': '204, 244, 220', 'usage': '' },
				{ 'name': 'S-Lighten 03', 'color':'success-lighten-03', 'hex': '#EDFAF3', 'rgb': '237, 250, 243', 'usage': '' },
			],
			ErrorExtendedColors: [
				{ 'name': 'Error', 'color':'error', 'hex': '#F44336', 'rgb': '244, 67, 54', 'usage': '' },
				{ 'name': 'E-Lighten 01', 'color':'error-lighten-01', 'hex': '#FFE082', 'rgb': '249, 160, 154', 'usage': '' },
				{ 'name': 'E-Lighten 02', 'color':'error-lighten-02', 'hex': '#FFF3CD', 'rgb': '253, 217, 215', 'usage': '' },
				{ 'name': 'E-Lighten 03', 'color':'error-lighten-03', 'hex': '#FFFAED', 'rgb': '254, 242, 240', 'usage': '' },
			],
			WarningExtendedColors: [
				{ 'name': 'Warning', 'color':'warning', 'hex': '#FFC107', 'rgb': '255, 193, 7', 'usage': '' },
				{ 'name': 'W-Lighten 01', 'color':'warning-lighten-01', 'hex': '#FFE082', 'rgb': '255, 224, 130', 'usage': '' },
				{ 'name': 'W-Lighten 02', 'color':'warning-lighten-02', 'hex': '#FFF3CD', 'rgb': '255, 243, 205', 'usage': '' },
				{ 'name': 'W-Lighten 03', 'color':'warning-lighten-03', 'hex': '#FFFAED', 'rgb': '255, 250, 237', 'usage': '' },
			],
			InfoExtendedColors: [
				{ 'name': 'Information', 'color':'info', 'hex': '#7364FF', 'rgb': '115, 100, 255', 'usage': '' },
				{ 'name': 'I-Lighten 01', 'color':'info-lighten-01', 'hex': '#B9B1FF', 'rgb': '158, 177, 255', 'usage': '' },
				{ 'name': 'I-Lighten 02', 'color':'info-lighten-02', 'hex': '#E3E0FF', 'rgb': '227, 224, 255', 'usage': '' },
				{ 'name': 'I-Lighten 03', 'color':'info-lighten-03', 'hex': '#F5F4FF', 'rgb': '245, 244, 255', 'usage': '' },
			],
		}
	},
	computed: {

	},
	methods: {

	}
}
</script>
<style lang="scss" scoped>
@import "../plugins/mtui/styles/Variables.scss";
	h2 { clear: both; }
	.color-box {
		display: flex;
		flex-direction: column;
		width: 200px;
		font-size: 14px;
		float: left;
		margin-right: 40px;
		margin-bottom: 50px;
		&>div { width: 100%; }
		.color{
			height: 175px;
			&.white {
				border: 1px solid $c-neutrals-light-gray-01;
			}
		}
		.desc {
			padding: 10%;
			&.white {
				border: 1px solid $c-neutrals-light-gray-01;
			}
			.name { font-weight: bold; }
			.label { font-size: 12px; padding-right: 30px;}
			.value { color: #011b32; }
		}
		.usage { padding-top: 25px; }

	 &--type2 {
		 margin-right: 0;
		 width: 130px;
		 .desc { padding: 0; border: 0; }
		 .color{ height: 130px; }
		 .name { padding-top: 40px; }
		 .label{ display: block; padding-top: 15px; padding-bottom: 5px; }
	 }
	}
</style>



// WEBPACK FOOTER //
// Colors.vue?09966430